import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    }
    // else {
    //   body.classList.toggle("vertical-collpsed");
    //   body.classList.toggle("sidebar-enable");
    // }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            {/* <li className="menu-title">{props.t("Apps")}</li> */}

            <li>
              <Link onClick={e => tToggle()} to="/delear-dashboard">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("Equipments Products")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-tag-product-from-admin"
                  >
                    {props.t("Tagged Products from Admin")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-reselling-product-list"
                  >
                    {props.t("Equipments Products List")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-new-product-request"
                  >
                    {props.t("New Products Requests")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-tagged-customer-list"
                  >
                    {props.t("Tagged Customers List")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-task"></i>
                <span>{props.t("Consumables Products")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-maintain-inventory"
                  >
                    {props.t("Maintain Inventory")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/delear-view-inventory">
                    {props.t("View Inventory")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-tagged-consumables-product-by-admin"
                  >
                    {props.t("Tagged Consumables Products by Admin")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/delear-new-order-request">
                    {props.t("New orders Requests")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-new-order-request-from-customer"
                  >
                    {props.t("New orders Requests from Customers")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-briefcase"></i>
                <span>{props.t("Demo Products")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-demo-product-tag-product-from-admin"
                  >
                    {props.t("Tagged Products from Admin")}
                  </Link>
                </li>
                <li>
                  <Link onClick={e => tToggle()} to="/delear-demo-product-list">
                    {props.t("Demo Products List")}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-demo-tagged-product-list"
                  >
                    {props.t("Tagged Products List")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link onClick={e => tToggle()} to="/delear-customer">
                <i className="bx bxs-user-detail"></i>
                <span>{props.t("Customers")}</span>
              </Link>
            </li>

            <li>
              <Link to="/dashboard" className="has-arrow">
                <i className="bx bx-receipt"></i>
                <span>{props.t("Earnings")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-reselling-products"
                  >
                    {props.t("Total Products Sold")}
                  </Link>
                </li>
                {/* <li>
                  <Link
                    onClick={e => tToggle()}
                    to="/delear-earnings-manufactured-products"
                  >
                    {props.t("New Order Sold")}
                  </Link>
                </li> */}
              </ul>
            </li>

            <li>
              <Link onClick={e => tToggle()} to="/delear-service">
                <i className="bx bx-envelope"></i>
                <span>{props.t("Services")}</span>
              </Link>
            </li>

            <li>
              <Link onClick={e => tToggle()} to="/delear-buyback">
                <i className="bx bx-tone"></i>
                <span>{props.t("Refurbished")}</span>
              </Link>
            </li>

            <li>
              <Link onClick={e => tToggle()} to="/delear-contact-support">
                <i className="bx bx-support"></i>
                <span>{props.t("Contact Us")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
